export const SEARCH_INPUT_PARTS = [
  'container',
  'field',
  'element',
  'hint',
  'hintWrapper',
] as const;
